module.exports = __webpack_public_path__ + "img/hand-heart.80c523cc.svg";